import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import {reactSelectStyle} from 'helpers';

const style = {height: 44};
export default React.memo(
  ({item, prop, handleChange, setSelectOpen: setSelectOpenMainFunc}) => {
    const teams = useSelector((state) => state.team.teams);

    const teamOptions = useMemo(
      () =>
        teams.map((team) => ({
          label: team.name,
          value: {teamName: team.name, teamId: team._id},
        })),
      [teams]
    );

    const name = 'teams';
    const setSelectOpen = setSelectOpenMainFunc(name);

    return (
      <div
        className="input-container custom-input-box box-input-container"
        style={style}
      >
        <div className="d-flex align-items-center box h-100">
          <div className="d-flex justify-content-center align-items-center h-100 select-team-text-container">
            <div className="title">TEAM</div>
          </div>
          <div className="input-container flex-grow-1">
            <CreatableSelect
              isClearable
              menuPlacement="auto"
              styles={reactSelectStyle({hide: !!item[prop]})}
              value={teamOptions.find((t) => t.value.teamName === item[prop])}
              onChange={(newValue) => {
                if (newValue) {
                  handleChange('teamName', newValue.value.teamName);
                  handleChange('teamId', newValue.value.teamId);
                } else {
                  handleChange('teamName', '');
                  handleChange('teamId', '');
                }
              }}
              placeholder=""
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={teamOptions}
              onMenuClose={() => {
                setSelectOpen(false);
              }}
              onMenuOpen={() => {
                setSelectOpen(true);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);
